import React from 'react';

const LeftTriangleIcon = () => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9802 5.82L10.7702 9.03L8.80023 10.99C7.97023 11.82 7.97023 13.17 8.80023 14L13.9802 19.18C14.6602 19.86 15.8202 19.37 15.8202 18.42V12.81V6.58C15.8202 5.62 14.6602 5.14 13.9802 5.82Z'
        fill='#2F80ED'
      />
    </svg>
  );
};

export default LeftTriangleIcon;
